export const SET_THEME = 'SET_THEME';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const SET_REFECH_METHOD = 'SET_REFECH_METHOD';

// Chart Type
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';
export const SET_TRANSACTION_NUMBER = 'SET_TRANSACTION_NUMBER';
